import React from "react";
import { motion } from "framer-motion";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { fadeUp } from "./anim";

const FAQ = [
  { q: "Is HostGuard a guest blacklist?", a: "No. HostGuard is explicitly not a blacklist. We never store or expose guest names, never let you search guests by name, and never accuse any guest of wrongdoing. We only assess the characteristics of a booking you enter." },
  { q: "How is the risk score calculated?", a: "The score is calculated by a deterministic formula based on booking characteristics such as lead time, reviews, group size, and message quality. The same inputs always produce the same score. AI is used only to write a neutral summary — it never changes the score." },
  { q: "Do you verify guest identity?", a: "No. HostGuard does not verify identity and does not make booking decisions for you. It provides guidance only — you remain in full control and responsible for complying with platform policies and applicable laws." },
  { q: "What data do you store about guests?", a: "Only initials and the booking characteristics you choose to enter. There is no public guest database, and your assessments are private to your account." },
  { q: "Can I cancel anytime?", a: "Yes. You can stay on the Free plan or upgrade and manage your subscription at any time from Settings." },
];

export const LandingFAQ = () => (
  <section id="faq" className="mx-auto max-w-3xl px-4 py-16 sm:px-6">
    <motion.div {...fadeUp} className="text-center">
      <h2 className="font-display text-3xl font-semibold tracking-tight">Frequently asked questions</h2>
    </motion.div>
    <Accordion type="single" collapsible className="mt-8">
      {FAQ.map((item, i) => (
        <AccordionItem key={item.q} value={`item-${i}`} data-testid={`faq-item-${i}`}>
          <AccordionTrigger className="text-left font-medium">{item.q}</AccordionTrigger>
          <AccordionContent className="text-muted-foreground">{item.a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </section>
);
